import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import React from "react";
import CloseIcon from "../../assets/images/CloseModalIcon.svg";
import { ModalSkeletonProvider } from "../SkeletonLoading/ModalSkeletonContext";
import { DialogHeader } from "../ui/dialog";

// import { Container } from './styles';

interface Props {
  title?: string;
  children: JSX.Element;
  header?: JSX.Element;
  // childrenFooter: JSX.Element;
  isScreenLg?: boolean;
  isScreenXl?: boolean;
  maxWidth?: string;
  onClose: () => void;
  
  // onConfirm: () => void;
  // onCancel: () => void;
}

const BootstrapDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'isScreenLg' && prop !== 'isScreenXl' && prop !== 'customMaxWidth',
})<{ isScreenLg?: boolean; isScreenXl?: boolean; customMaxWidth?: string }>(({ isScreenLg, isScreenXl, customMaxWidth }) => ({
  "& .MuiPaper-root": {
    minWidth: isScreenXl ? "1200px" : isScreenLg ? "900px" : "500px",
    maxWidth: customMaxWidth || "calc(100vw - 24px)",
    width: customMaxWidth || undefined,
    maxHeight: "calc(100dvh - 24px)",
    // minHeight: '800px',
    borderRadius: "10px",
    zIndex: 9999999
  },
  "& .MuiDialogContent-root": {
    minWidth: "500px",
    maxWidth: customMaxWidth || "1400px",
    width: customMaxWidth ? "100%" : undefined,
    height: '100%',
    overflow: "hidden",
    // padding: theme.spacing(2),
    padding: 0,
    background: "hsl(var(--modal-surface))",
    // Âncora do skeleton de modal, que é renderizado em overlay absoluto.
    position: "relative",
    "--skeleton-surface": "var(--modal-surface)",
  },
  "& .MuiDialogActions-root": {
    // width: '100%',
    // minWidth: '800px',
    justifyContent: "flex-start",
    // padding: theme.spacing(1),
    // marginLeft: '0.850rem'
  },
  "& .MuiDialogHeader-root": {
    height: "44px",
  },
  "& .MuiDialogFooter-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "54px",
  },
  "@media (max-width: 768px)": {
    "& .MuiPaper-root": {
      width: "calc(100vw - 16px)",
      minWidth: "unset",
      margin: "8px",
      borderRadius: "8px",
    },
    "& .MuiDialogContent-root": {
      minWidth: "unset",
      width: "100%",
      maxHeight: "calc(100dvh - 72px)",
      overflow: "auto",
    },
  },
}));

const CustomModal: React.FC<Props> = (props: Props) => {
  return (
    <BootstrapDialog
      isScreenLg={props.isScreenLg}
      isScreenXl={props.isScreenXl}
      customMaxWidth={props.maxWidth}
      // onClose={() => {
      //   props.onClose();
      //   window.location.reload();
      // }}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <DialogHeader className="">
        {props.header ? (
          <>{props.header}</>
        ) : (
          <DialogTitle
            sx={{
              m: 0,
              // p: 2,
              // fontSize: "1.5rem",
              // fontWeight: "bold",
              // color: "#282828",
            }}
            className="text-lg font-semibold"
            id="modalTitle"
          >
            {props.title}
          </DialogTitle>
        )}

        <IconButton
          aria-label="close"
          onClick={() => {
            props.onClose();
          }}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 2,
            color: theme.palette.grey[500],
          })}
          id="btnClose"
        >
          <img src={CloseIcon} className="w-4 h-4" />
        </IconButton>
      </DialogHeader>

      <DialogContent style={{ maxWidth: "100%" }}>
        <ModalSkeletonProvider surface="dialog">
          {props.children}
        </ModalSkeletonProvider>
      </DialogContent>
      {/* 
      <DialogFooter>
        
      </DialogFooter> */}
    </BootstrapDialog>
  );
};

export default CustomModal;
